class AppException extends Error {
  constructor(code, message) {
    super(message);
    this.name = "AppException";
    this.code = code; 
    this.message = message
  }
}

export default AppException;